import React from 'react';
import st from './style.module.css';

const ArticalCard = ({ article }) => {
  const { category, post_title, main_image, slug } = article;
  const imageUrl = process.env.NEXT_PUBLIC_IMAGE_PATH + main_image;

  return (
    <div>
      <div className="md:flex hidden flex-col gap-[30px] relative min-w-[350px] min-h-[320px]">
        <div className="bg-gray-300 md:max-w-[322px] md:h-[214px] maw-w-[345px] h-[213px] rounded-[10px] overflow-hidden relative top-0 left-0">
          <img className="object-cover w-full h-full" src={imageUrl} alt={post_title} />
        </div>
        <div className="md:w-[322px] min-h-[180px] flex justify-between flex-col absolute md:bottom-0 md:right-0 bg-white rounded-[10px]  py-[16px] px-[22px]">
          <div className="flex flex-col gap-[22px]">
            <p
              className={`border-1  text-[12px] leading-[14px] font-[600] px-[16px] py-[6px] rounded-[38px] max-w-min whitespace-nowrap`}
              style={{ color: category.color, borderColor: category.color }}
            >
              {category.name}
            </p>
            <a href={`/blog/${slug}`}>
              <p className={`text-[18px] font-[600] leading-[22px] ${st['line-clamp-3']}`}>{post_title}</p>
            </a>
          </div>
          <a
            href={`/blog/${slug}`}
            className="flex w-full text-[#09AF77] hover:text-black text-[16px] font-[400] leading-[20px]  items-center gap-[10px]"
          >
            Read More
            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.230469 11.1336L4.61964 6.73486L0.230469 2.33611L1.58172 0.984863L7.33172 6.73486L1.58172 12.4849L0.230469 11.1336Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="md:hidden flex flex-col gap-[24px]">
        <div className="bg-gray-300 maw-w-[320px] rounded-[10px] overflow-hidden">
          <img className="object-cover w-full h-full" src={imageUrl} alt={post_title} />
        </div>
        <div className="flex flex-col bg-white rounded-[10px] gap-[16px]">
          <div className="flex flex-col gap-[22px]">
            <p
              className="border-1 text-[12px] leading-[14px] font-[600] px-[16px] py-[6px] rounded-[38px] max-w-min whitespace-nowrap"
              style={{ color: category.color, borderColor: category.color }}
            >
              {category.name}
            </p>
            <a href={`/blog/${slug}`}>
              <p className={`text-[18px] font-[600] leading-[22px] ${st['line-clamp-3']}`}>{post_title}</p>
            </a>
          </div>
          <a
            href={`/blog/${slug}`}
            className="flex w-full text-[#09AF77] hover:text-black text-[16px] font-[400] leading-[20px]  items-center gap-[10px]"
          >
            Read More
            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.230469 11.1336L4.61964 6.73486L0.230469 2.33611L1.58172 0.984863L7.33172 6.73486L1.58172 12.4849L0.230469 11.1336Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ArticalCard;
